import React, { useRef } from 'react'
import CustomButton from '../../../features/customButton/ui/main/CustomButton'
import classNames from 'classnames'
import { customizationContent } from '../../../../constants/copyright'
import { safeHTML } from '../../../../utils/safeHTML'
import { useCustomizationShowAnimation } from './customizationFiltersShowAnimation'
import { useTranslation } from '../../../../translations'

const CustomizationFiltersItem = React.forwardRef(function CustomizationFiltersItem(
  { title, system_name, image, array, customState, isNew, setFilter, index },
  ref,
) {
  const itemRef = useRef(null)
  const imageRef = useRef(null)
  const titleRef = useRef(null)
  const { t } = useTranslation()

  const setFilterCallback = () => {
    array?.length && setFilter(system_name)
  }

  useCustomizationShowAnimation({ index, itemRef, imageRef, titleRef })

  return (
    <div
      className={classNames(
        'customization__filter-box',
        `customization__filter-box_${customState}`,
        {
          'customization__filter-box_inactive': !array.length,
        },
      )}
      ref={itemRef}
    >
      <div className={'customization__filter-content'}>
        <CustomButton
          onClick={setFilterCallback}
          className={classNames('customization__filter button_filter', {
            'button_filter-room': customState === 'room',
          })}
        >
          {image && (
            <div
              className={'button__icon button_transparent custom-button__icon'}
              ref={imageRef}
            >
              <img
                src={image}
                alt={''}
              />
            </div>
          )}
        </CustomButton>

        <div
          ref={titleRef}
          className={'customization__filter-title'}
        >
          {safeHTML(title)}
        </div>

        {isNew && (
          <span className={'customization__filter-new'}>{t(customizationContent.newText)}</span>
        )}
      </div>
    </div>
  )
})
export default CustomizationFiltersItem
CustomizationFiltersItem.propTypes = {}
